import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientAllergyControllerApi } from "../../services";
import { Patientallergy } from "../../services";
import {
  DGT_Pagination,
  Page,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
} from "../../utils/utils";

interface Props {
  patientUuid: string;
  pagination: DGT_Pagination;
  searchString?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

interface AllergyListResponse {
  content: Patientallergy[];
  page: Page;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientPortalAllergyListHealthRecord = ({
  patientUuid,
  pagination,
  searchString,
  xTENANTID,
  enabled = true,
}: Props) => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  return useQuery({
    queryKey: [
      "patient-portal-allergy-list",
      patientUuid,
      pageIndex,
      pageSize,
      searchString,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled && !!patientUuid,
    queryFn: async () =>
      await new PatientAllergyControllerApi(getConfigObject())
        .getPatientPortalAllergies(
          patientUuid,
          pageIndex,
          pageSize,
          xTENANTID
        )
        .then((res) => (res?.data?.data ?? res?.data) as AllergyListResponse),
  });
};
